import { inject, Injectable } from '@angular/core';
import { AppLanguageService } from '@services/app-language.service';
import { KuiThemeService } from '@kone/ui';

@Injectable({
	providedIn: 'root',
})
export class AppStarterService {
	private appLanguageService: AppLanguageService = inject(AppLanguageService);
	private themeService: KuiThemeService = inject(KuiThemeService);

	constructor() {
		const prefersDark = window.matchMedia('(prefers-color-scheme: dark)');

		prefersDark.addEventListener('change', e => {
			const current = this.themeService.current().value;
			const wanted = e.matches ? 'dark' : 'light';
			if (current !== wanted) this.themeService.trigger();
		});
	}

	initServices(): void {
		const prefersDark = window.matchMedia('(prefers-color-scheme: dark)');
		this.themeService.init(prefersDark.matches ? 'dark' : 'light');
		this.appLanguageService.fnInit();
	}
}
